import React, { useEffect, useState } from "react";
import CloudStorage from "../../../../../../CloudStorage/CloudStorage";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import PostNotFound from "../../../../../CustomComponents/AllLoader/PostNotFound";
import { getMineUmbrallaPosts } from "../../../../../../redux/umbrella/action";
import { getPercentage } from "../../../../../Common/FewCommonMethods";
import CustomeCircularProgressbar from "../../../../../Common/CustomeLabel/CustomeCircularProgressbar";

export default function PostedUmbrellaProjects({postcounts}) {
  const navigate = useNavigate();
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const dispatch = useDispatch();
  const postlistmine = useSelector(
    ({ umbrella: { umbrellapostlistmine } }) => umbrellapostlistmine
  );

  useEffect(() => {
    dispatch(getMineUmbrallaPosts(1));
  }, [dispatch]);

  const postedumbreallaproject = Array.isArray(postlistmine)
    ? postlistmine.filter((item) => item.status == 1)
    : [];
  const activeContests = Array.isArray(postlistmine)
    ? postlistmine.filter((item) => item.status == 2)
    : [];
  const completedContests = Array.isArray(postlistmine)
    ? postlistmine.filter((item) => item.status == 3)
    : [];

  return (
    <>
      <div className="posted-project umbrellaproject-sec">
        <div className="d-flex justify-content-between align-items-center post-umbrella-flex">
          <h4>Posted umbrella projects ({parseInt(postcounts?.umbrella_project || 0)})</h4>
         {postlistmine.length>0&& <button
            className="buttons background-button"
            onClick={() =>
              navigate(`/${lan}/dashboard/myorders/umbrella/listings`)
            }
          >
            View More
          </button>}
        </div>
        <div className="recent-post">
          {postedumbreallaproject.length == 0 ? (
            <PostNotFound title={"No Post Found"} />
          ) : (
            postedumbreallaproject.slice(0, 10).map((item, index) => (
              <div key={index} className="post-back">
                <div className="col-md-2 col-6 mx-auto">
                  <CustomeCircularProgressbar
                    percentage={getPercentage(
                      item?.total_milestone,
                      item?.completed_milestone
                    )}
                  />
                </div>
                <div className="col-md-7 padding-zero">
                  <h6>{item?.ambrella_title}</h6>
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <th>Applicants</th>
                        <th>Total sub projects</th>
                        <th>Hired experts</th>
                        <th>Total Experts</th>
                        <th>Total cost</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{item?.proposed_experts || 0}</td>
                          <td>{item?.total_sub_projects || 0}</td>
                          <td>{item?.hired_experts || 0}</td>
                          <td>{item?.proposed_experts || 0}</td>
                          <td>SAR {item?.total_price || 0}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <button
                  onClick={() =>
                    navigate(
                      `/${lan}/dashboard/myorders/umrellaproject/${item.id}`
                    )
                  }
                  className="btn"
                >
                  View details
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                    alt=""
                  />
                </button>
              </div>
            ))
          )}
        </div>

        <h4>Active umbrella projects ({parseInt(postcounts?.recent_umbrella_project || 0)})</h4>
        <div className="recent-post">
          {activeContests.length == 0 ? (
            <PostNotFound title={"No Post Found"} />
          ) : (
            activeContests.slice(0, 10).map((item, index) => (
              <div key={index} className="post-back">
                <div className="col-md-2 col-6 mx-auto">
                  <CustomeCircularProgressbar
                    percentage={getPercentage(
                      item?.total_milestone,
                      item?.completed_milestone
                    )}
                  />
                </div>
                <div className="col-md-7 padding-zero">
                  <h3>{item.ambrella_title}</h3>
                  <div className="table-responsive">
                    <table className="table">
                      <thead>
                        <th>Milestones completed</th>
                        <th>Completed sub projects</th>
                        <th>Total hired Experts</th>
                        <th>Total cost</th>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            {item?.completed_milestone} out of {" "}
                            {item?.total_milestone}
                          </td>
                          <td>
                            {item?.completed_sub_projects} out of {" "}
                            {item?.total_sub_projects}
                          </td>
                          <td>{item?.hired_experts || 0}</td>
                          <td>SAR {item?.total_price || 0}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <button
                  onClick={() =>
                    navigate(
                      `/${lan}/dashboard/myorders/umrellaproject/${item.id}`
                    )
                  }
                  className="btn"
                >
                  View details
                  <img
                    src={`${CloudStorage.cloudurl}/Assets/Images/homepage/right-arrow-orange.svg`}
                    alt=""
                  />
                </button>
              </div>
            ))
          )}
        </div>
      </div>
    </>
  );
}
